// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"1833212c","179":"80c45715"}[chunkId] + ".chunk.js";
};